import { setTokenGetter } from "./tokenProvider";
import { setErrorInterceptorHandlers } from "./interceptors/errorInterceptor";

export interface ApiInitOptions {
    getToken: () => Promise<string | undefined>;
    onLogout: () => Promise<void>;
    onRefreshToken: () => Promise<boolean>;
}

/**
 * Initialize the API layer. Call once at app startup.
 * Pass token getter and auth handlers (from Cognito/auth service).
 */
export function initApi(options: ApiInitOptions): void {
    setTokenGetter(options.getToken);
    setErrorInterceptorHandlers(options.onLogout, options.onRefreshToken);
}
